/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDataKey } from './businessObjectDataKey';


export interface BusinessObjectDataParentsUpdateRequest { 
    /**
     * An optional list of Business Object Data parents (i.e. predecessors) that were used/needed in the creation of this data. This                   is used for data lineage. Each parent consists of the key data that uniquely defines a reference to a single Business Object Data.                
     */
    businessObjectDataParents?: Array<BusinessObjectDataKey>;
}
